import { AudiencePageTemplate } from '@/components/AudiencePageTemplate'
import { getAudienceSegment } from '@/data/whoWeServe'

export default function MusicFestivalsPage() {
  return <AudiencePageTemplate segment={getAudienceSegment('music-festivals')} />
}
